<template>
    <div class="confirms">
        <Popup :value="show" :close-on-click-overlay="false">
            <div class="box">
                <div class="content">
                    <div class="content-title">{{title}}</div>
                    <div class="content-desc">{{desc}}</div>
                </div>
                <div class="group-btn">
                    <slot name="bottom">
                        <VanButton class="btn" @click="$emit('confirm')">{{ confirmButtonText }}</VanButton>
                    </slot>
                </div>

            </div>
        </Popup>
    </div>
</template>

<script>
    import {Popup, Button as VanButton} from 'vant';

    export default {
        name: 'Confirm',
        props: {
            show: Boolean,
            title: {
                type: String,
                default: '提示'
            },
            desc: String,
            confirmButtonText: {
                type: String,
                default: '我知道了'
            },
        },
        data: function () {
            return {}
        },
        methods: {},
        components: {Popup, VanButton}
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .confirms {
        .van-popup {
            border-radius: 5px;
        }

        .box {
            width: 295px;
            padding: 20px 24px;
            display: flex;
            flex-direction: column;
            align-items: center;
            overflow: hidden;

            .content {
                text-align: center;
                width: 100%;
                padding: 20px 0 30px;
                color: #222;

                &-title {
                    font-size: 19px;
                    text-align: center;
                    font-weight:500;
                    color:rgba(34,34,34,1);
                    margin-bottom: 20px;
                }
                &-desc {
                    font-size:16px;
                    font-weight:400;
                    color:rgba(34,34,34,.8);
                    text-align: center;
                }
            }

            .group-btn {
                width: 100%;
                height: 40px;
                display: flex;
                justify-content: space-between;

                .btn {
                    width: 244px;
                    height: 40px;
                    line-height: 38px;
                    background: rgba(254, 219, 7, 1);
                    box-shadow: 0 0 15px 0 rgba(199, 140, 69, 0.1);
                    border-radius: 20px;
                    text-align: center;
                    font-size: 16px;
                    border: none;
                }

                .cancel {
                    color: #6B7993;
                    border: 1px solid #969FA9;
                }

                .confirm {
                    background: #FF5555;
                    font-size: 16px;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 1);
                }
            }
        }
    }

</style>
